export const tokenRoundelConfig = {
  inline: {
    ringText: "$BRACKY ON BASE / OFFICIAL BETTING TOKEN /",
    letterSpacing: "0",
    wordSpacing: "0",
    fontSize: "10.2px",
    textLength: 283, // approx circumference of 45px radius circle
    ringColor: "#ffffff",
  },
  portal: {
    ringText: "BRACKET / BET LIVE NOW / LIVE THE GAME / $BRACKY /",
    letterSpacing: ".57px",
    wordSpacing: "-0.2rem",
    fontSize: "9.5px",
    ringColor: "#0074FF",
  },
  animation: {
    tokenBobbing: {
      duration: 2,
      ease: "easeInOut",
      values: [0.62, -0.62, 0.62],
    },
    ringRotation: {
      duration: 20,
      ease: "linear",
    },
    shimmerGradient: {
      duration: 7,
    },
    fadeTransition: {
      duration: 0.3,
      ease: "easeOut",
    },
    resizeDebounce: 150,
  },
  scroll: {
    pollInterval: 100,
    maxAttempts: 10,
    behavior: "smooth" as const,
  },
  responsive: {
    fallbackNavHeight: {
      mobile: 64,
      desktop: 90,
    },
  },
  assets: {
    tokenImage: "https://a.bracky.app/assets/landing/backgrounds/bracky-token-blue.webp",
    rotatingRing: "https://a.bracky.app/assets/landing/backgrounds/token-roundel-text-779.png",
  },
}
